import { useEffect, useState } from "react";
import { TIENDA, MENSAJE_COMPRA } from "../data/config";
import { useWhatsApp } from "../hooks/useWhatsApp";
import Boton from "./ui/Boton";
import IconoWhatsApp from "./ui/IconoWhatsApp";

const ENLACES = [
  { href: "#producto", texto: "Producto" },
  { href: "#beneficios", texto: "Beneficios" },
  { href: "#testimonios", texto: "Reseñas" },
  { href: "#nosotros", texto: "Nosotros" },
  { href: "#contacto", texto: "Contacto" },
];

const Navbar = () => {
  const { abrirWhatsApp } = useWhatsApp();
  const [conSombra, setConSombra] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);

  // Anade sombra a la barra al hacer scroll para diferenciarla del hero.
  useEffect(() => {
    const alScrollear = () => setConSombra(window.scrollY > 20);
    window.addEventListener("scroll", alScrollear);
    return () => window.removeEventListener("scroll", alScrollear);
  }, []);

  const cerrarMenu = () => setMenuAbierto(false);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 bg-cream/90 backdrop-blur transition-shadow duration-300 ${
        conSombra ? "shadow-soft" : ""
      }`}
    >
      <nav className="mx-auto flex max-w-container items-center justify-between px-5 py-4 md:px-16">
        <a href="#inicio" className="flex items-center gap-2" onClick={cerrarMenu}>
          <span className="font-literata text-2xl font-bold tracking-tight text-charcoal">
            {TIENDA.nombre}
          </span>
          <span className="hidden text-xs font-medium uppercase tracking-label text-secondary sm:inline">
            Maní Natural
          </span>
        </a>

        {/* Enlaces de escritorio */}
        <ul className="hidden items-center gap-8 lg:flex">
          {ENLACES.map((enlace) => (
            <li key={enlace.href}>
              <a
                href={enlace.href}
                className="text-sm font-medium text-ink-variant transition-colors hover:text-charcoal"
              >
                {enlace.texto}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <Boton
            variante="primario"
            className="hidden sm:inline-flex"
            onClick={() => abrirWhatsApp(MENSAJE_COMPRA)}
          >
            <IconoWhatsApp className="text-xl" />
            Comprar
          </Boton>

          {/* Boton hamburguesa (movil) */}
          <button
            type="button"
            className="flex h-12 w-12 items-center justify-center rounded-lg text-charcoal lg:hidden"
            aria-label={menuAbierto ? "Cerrar menú" : "Abrir menú"}
            aria-expanded={menuAbierto}
            onClick={() => setMenuAbierto((abierto) => !abierto)}
          >
            <svg
              viewBox="0 0 24 24"
              width="2.4rem"
              height="2.4rem"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              aria-hidden="true"
            >
              {menuAbierto ? (
                <path d="M6 6l12 12M18 6L6 18" />
              ) : (
                <path d="M4 7h16M4 12h16M4 17h16" />
              )}
            </svg>
          </button>
        </div>
      </nav>

      {/* Menu desplegable movil */}
      {menuAbierto && (
        <ul className="border-t border-peanut/30 bg-cream px-5 py-4 lg:hidden">
          {ENLACES.map((enlace) => (
            <li key={enlace.href}>
              <a
                href={enlace.href}
                onClick={cerrarMenu}
                className="block py-3 text-base font-medium text-ink-variant transition-colors hover:text-charcoal"
              >
                {enlace.texto}
              </a>
            </li>
          ))}
          <li className="pt-3">
            <Boton
              variante="primario"
              className="w-full"
              onClick={() => {
                cerrarMenu();
                abrirWhatsApp(MENSAJE_COMPRA);
              }}
            >
              <IconoWhatsApp className="text-xl" />
              Comprar por WhatsApp
            </Boton>
          </li>
        </ul>
      )}
    </header>
  );
};

export default Navbar;
